import {toQueryString} from '@s-ui/js/lib/string'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
import NewsEntitiesFactory from '../Entities/factory.js'
import {NewsErrorsFactory} from '../Errors/factory.js'
import NewsMappersFactory from '../Mappers/factory.js'
import NewsUseCasesFactory from '../UseCases/factory.js'
import NewsValueObjectsFactory from '../ValueObjects/factory.js'
import HTTPNewsRepository from './HTTPNewsRepository.js'
import PaginationRepository from './PaginationRepository.js'

export default class NewsRepositoriesFactory {
  static hTTPNewsRepository = ({config}) =>
    new HTTPNewsRepository({
      articleEntityFactory: NewsEntitiesFactory.articleEntity,
      articleImageEntityFactory: NewsEntitiesFactory.articleImageEntity,
      config,
      fetcher: FetcherFactory.httpFetcher({config}),
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      getVehicleNewsError: NewsErrorsFactory.getVehicleNewsError,
      getModelDetailNewsError: NewsErrorsFactory.getModelDetailNewsError,
      homeNewsValueObjectFactory: NewsValueObjectsFactory.homeNewsValueObject,
      modelDetailNewsValueObjectFactory: NewsValueObjectsFactory.modelDetailNewsValueObject,
      log: factoryLogger({prefix: 'HTTPNewsRepository'}),
      newsValueObjectFactory: NewsValueObjectsFactory.newsValueObject,
      newsSuggestionsValueObjectFactory: NewsValueObjectsFactory.newsSuggestionsValueObject,
      tagEntityFactory: NewsEntitiesFactory.tagEntity,
      toQueryString,
      getNewsDetailError: NewsErrorsFactory.getNewsDetailError,
      fromNewsDetailResponseToEntityMapper: NewsMappersFactory.fromNewsDetailResponseToEntityMapper({config}),
      getSubscribeToNewsletterError: NewsErrorsFactory.getSubscribeToNewsletterError,
      latestPlatesValueObjectFactory: NewsValueObjectsFactory.latestPlatesValueObject
    })

  static paginationRepository = ({config}) =>
    new PaginationRepository({
      newsPaginationValueObjectFactory: NewsValueObjectsFactory.newsPaginationValueObject({
        config
      }),
      newsSearchUrlBuilder: NewsUseCasesFactory.getNewsSearchUrlUseCase({
        config
      })
    })
}
